export default "__VITE_ASSET__BBkj2eNx__";